
import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../withItemCache/WithItemCache';
import { childItemsFacet } from '../../facets/SetFacets';
import { itemPageIsBlocked } from '../../operations/blockItemPage';

/**
 * Props for an ItemPage.
 * @public
 */
export interface IItemPageProps {
    /**
     * The key for a page item.
     */
    itemKey: string;
    showEmptyItem?: boolean;
}

/**
 * Component which renders empty content, while demanding the child items
 * for a page with the given input item key.
 *
 * Render this component within a virtualized list to force expansion of the
 * paged items only when the list needs to render the content.
 * @public
 */
export class ItemPage extends React.PureComponent<IItemPageProps> {
    public render(): JSX.Element {
        const {
            itemKey,
            showEmptyItem
        } = this.props;

        return (
            <WithItemCache>
                {
                    ({ itemCache }: IItemCacheStateProps) => {
                        const isBlocked = itemPageIsBlocked(itemCache);

                        // When the component is finally rendered, demand the child items for the page.
                        if (!isBlocked) {
                            itemCache.demandItemFacet(childItemsFacet, itemKey);
                        }

                        return (
                            showEmptyItem ?
                                <div style={ { height: '80px' } } /> :
                                null
                        );
                    }
                }
            </WithItemCache>
        );
    }
}
